import React from 'react';
import {DefaultPageLayout} from "./_layouts/DefaultPageLayout";
import {PriceTable} from "../sections/PriceTable";
import {Box} from "@modbros/components";
import {Flex} from "@modbros/components/layout";
import {Heading, Text} from "@modbros/components/typography";

export default function Pricing() {
    return (
        <DefaultPageLayout>
            <Box m = {32}>
                <Flex width={'100%'} alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
                    <Heading level={3}>Choose the plan that works for you!</Heading>
                    <Text>We have several powerful plans for you to choose from depending on your needs</Text>
                </Flex>
            </Box>
            <PriceTable/>
        </DefaultPageLayout>
    );
}

